import React from 'react';
import { AlertTriangle, Phone } from 'lucide-react';
import { LegalLayout, LegalSection } from './LegalLayout';

export const Disclaimer = () => {
  return (
    <LegalLayout
      title="Disclaimer"
      lastUpdated="Last Updated: June 01, 2026"
      testId="disclaimer-page"
    >
      <LegalSection heading="Not Medical Advice" testId="disclaimer-not-medical">
        <p>
          The information provided by Apex Athletic Mind Consulting LLC, including content within the Apex AI Coach app and the Apex Six framework, is intended for mental performance training and sports psychology education. Varsay Lewis and Apex Athletic Mind Consulting LLC are not acting as licensed clinical psychologists or medical doctors. Our services are not a substitute for professional mental health care or medical diagnosis.
        </p>
      </LegalSection>

      <LegalSection testId="disclaimer-crisis">
        <div
          className="rounded-2xl border border-[#B91C1C]/20 bg-[#FFF4F2] p-5 sm:p-6"
          role="alert"
          data-testid="disclaimer-crisis-callout"
        >
          <div className="flex items-start gap-3">
            <div className="shrink-0 p-2 rounded-lg bg-[#B91C1C]/10">
              <AlertTriangle className="h-5 w-5 text-[#B91C1C]" />
            </div>
            <div>
              <h2 className="font-heading text-[1.15rem] font-semibold text-[#1a1a1a] mb-1">
                Crisis Resources
              </h2>
              <p className="text-[#3a3a3a] mb-3">
                If you are experiencing a mental health crisis, do not use this website or the Apex AI Coach app. Please contact:
              </p>
              <ul className="space-y-2 text-[#1a1a1a]">
                <li className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-[#B91C1C]" />
                  <span><strong>Emergency Services:</strong> 911 (USA)</span>
                </li>
                <li className="flex items-center gap-2">
                  <Phone className="h-4 w-4 text-[#B91C1C]" />
                  <span><strong>Suicide &amp; Crisis Lifeline:</strong> 988 (Call or Text)</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </LegalSection>

      <LegalSection heading="Results Disclaimer" testId="disclaimer-results">
        <p>
          Athletic performance depends on numerous variables including physical talent, coaching, and effort. While our methodology is rooted in performance psychology, we make no guarantees regarding specific measurable results, such as team selection, wins, or professional recruitment.
        </p>
      </LegalSection>
    </LegalLayout>
  );
};

export default Disclaimer;
